import { redirect } from "@tanstack/react-router";
import { legacyMunicipalitySlugs } from "@/data/legacyMunicipalitySlugs";
import { municipalityBySlug } from "@/data/municipalities";

/** Kastar en permanent (301) omdirigering till angiven sökväg. */
export function permanentRedirect(href: string): never {
  throw redirect({ href, statusCode: 301 });
}

/**
 * Normaliserar en kommunslug från gamla URL:er: avkodar %-tecken, gör om
 * versaler till gemener och översätter å/ä/ö till a/a/o.
 */
export function normalizeMunicipalitySlug(slug: string): string {
  let value = slug;
  try {
    value = decodeURIComponent(slug);
  } catch {
    /* ogiltig kodning – använd rådata */
  }
  return value
    .trim()
    .toLowerCase()
    .replace(/[åä]/g, "a")
    .replace(/ö/g, "o")
    .replace(/é/g, "e")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** Aktuell kommunslug för en (eventuellt gammal eller felformaterad) slug. */
export function canonicalMunicipalitySlug(slug: string): string {
  const normalized = normalizeMunicipalitySlug(slug);
  return legacyMunicipalitySlugs[normalized] ?? normalized;
}

/**
 * Omdirigerar gamla eller felformaterade kommunslugar under en tjänstevertikal
 * (t.ex. /solceller/almhults -> /solceller/almhult, /elpriser/Borlänge -> /elpriser/borlange).
 */
export function redirectLegacyMunicipality(vertical: string, slug?: string) {
  if (!slug) return;
  const target = canonicalMunicipalitySlug(slug);
  if (target && target !== slug) permanentRedirect(`/${vertical}/${target}`);
}

/**
 * Gamla "billig el"-sidor från den tidigare sajten (WordPress), t.ex.
 * /billig-el, /billig-el-stockholm och /billig-el/stockholm. Kända
 * kommuner skickas till den lokala elprissidan, övriga till
 * /elavtal/billiga. Returnerar true om en omdirigering kastades.
 */
export function redirectLegacyBilligEl(path: string): boolean {
  const match = path.match(/^\/billig-el(?:[-/](.+))?$/i);
  if (!match) return false;
  const slug = match[1];
  if (slug) {
    const target = canonicalMunicipalitySlug(slug);
    if (target && municipalityBySlug(target)) {
      permanentRedirect(`/elpriser/${target}`);
    }
  }
  permanentRedirect("/elavtal/billiga");
}
